//BFSG
import useCart from 'hooks/account/cart/useCart'
import * as React from 'react'
import styled from 'styled-components'
import MiniCart from 'theme/molecules/account/MiniCart'
import withTranslations from '../withTranslations'
import useTranslations from 'hooks/useTranslations'

type Props = {
  'data-cy-state': string
}

export function CartPreview(props: Props) {
  const cart = useCart()
  const t = useTranslations<'account-Dashboard'>()
  const uuids = React.useMemo(() => {
    return cart.data.items.map((item) => item.sw6Uuid).filter(Boolean)
  }, [cart.data.items])

  return (
    <Wrapper className="CartPreview" data-cy-state={props['data-cy-state']}>
      <MiniCart
        sw6Uuids={uuids}
        actionButtonIcon="cart"
        actionButtonAriaLabel={t.asText(false, 'cartpreview_your_cart')}
        actionButtonLabel={t('cartpreview_show_cart')}
        actionButtonLink="/cart/"
      />
    </Wrapper>
  )
}
export default withTranslations(CartPreview)

const Wrapper = styled.div``
